import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {Shower} from "../../parts/shower";
import {METADATA, PAN_POSITIONS} from "../../constants";
import AccessoryCommon from "./accessoryCommon";

export default class SoapDish extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'soap_dish';
    this.partName = 'Soap Dish';
    this.translateId = "visualizer.bathroom.accessories.soap_dish";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      this.layerPositions = {
        [PAN_POSITIONS[0]]: null,
        [PAN_POSITIONS[1]]: null,
        [PAN_POSITIONS[2]]: null,
      };
    }
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : METADATA.LeftSide;
    if (Array.isArray(dbFeature.metaData["ShowerSize"])
      && (dbFeature.metaData["ShowerSize"].includes('30')
        || dbFeature.metaData["ShowerSize"].includes('30in')
        || dbFeature.metaData["ShowerSize"].includes('36')
        || dbFeature.metaData["ShowerSize"].includes('36in'))) {
      // we don't have L uploaded for small Shower sizes, only C, but we show L features in the navigation
      dbFeature.metaData["Side"] = [METADATA.LeftSide];
      dbFeature.metaData["layerPosition"] = METADATA.LeftSide;
    }
    const partNumber = dbFeature.metaData["layerPosition"] === PAN_POSITIONS[0] ? 1 : 2;
    return super.load_(dbFeature, new SoapDish(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  disabledClick() {
    if (!this.disabled && this.activeFeature) {
      this.activeFeature.handleClick() // check soapDish
    }
  }

  availableFeatures(features) {
    return features.filter(feature => feature.partNumber === 1)
  }

  handleClick() { // "this" is feature!! not the feature group
    super.handleClick();
    const parent = this.getParent();
    const accessoriesParent = parent.getParent();
    const showerParent = accessoriesParent.layout.parts[Shower.id];
    const showerSize = showerParent.showerSize();
    if ((showerSize === "30" || showerSize === "36") && parent.activeFeature) {
      parent.layerPositions[parent.activeFeature.metaData["layerPosition"]] = parent.activeFeature;
    }
  }

  setLayers(layout) {

    const showerParent = this.getParent().layout.parts[Shower.id];
    const showerComboParent = layout.parts[ShowerTubCombo.id];

    if (showerParent && showerComboParent && showerParent.showerTubComboIsActive() && showerComboParent.bottomTub === "walk_in_tub") {
      super.hideLayers();
      return;
    }

    const conditions = this.getArrayOfConditions();
    if ((this.activeFeature && this.activeFeature.matchesMetaForArrayOfConditions(conditions)
      || (this.activeFeature && this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  setZIndex(zIndexes) {
    if (zIndexes) {
      Object.keys(this.layerPositions).forEach((key, keyIndex) => {
        if (this.layerPositions[key]) {
          this.layerPositions[key].layer.zIndex = zIndexes.Accessories.SoapDish + keyIndex*10;
        }
      })
    }
  }
}
